(function(){
    'use strict';

    angular.module('dataHandlingConditionEmailEngagement', ['ngAnimate', 'journey.canvas.srv', 'ngModalDragabble'])
        .controller('conditionEmailEngagementCtrl', ['$scope', '$rootScope', '$timeout', 'canvasService', 'helpers', conditionEmailEngagementCtrl]);

    function conditionEmailEngagementCtrl($scope, $rootScope, $timeout, canvasService, helpers){
        $scope.displayEmailEngagementConditionOpt = false;
        $scope.displayError = false;
        $scope.descriptionEmpty = false;

        $rootScope.$on('displayConditionEmailEngagementModal', function(evt, conn, showTip) {
            var entry = document.getElementById(conn.id).getBoundingClientRect();

            $scope.top = entry.top;
            $scope.left = entry.left;
            $scope.entryTop = entry.top;
            $scope.showTip = showTip;
            $scope.modalPos = $scope.calculateModalPos($scope.top, $scope.left);
            $scope.displayEmailEngagementConditionOpt = true;
            $scope.connections = angular.copy(conn);
            $scope.displayError = false;
            $scope.descriptionEmpty = false;
            $scope.conditionList = $scope.getConditionList();
            $scope.emailList = helpers.jbContainsSendEmail();
            $scope.conditionError = [];
            $scope.emailError = false;

            $(window).resize(function() {
                var entry = document.getElementById($scope.connections.id).getBoundingClientRect();
                $scope.$apply(function()  {
                    $scope.top = entry.top;
                    $scope.left = entry.left;
                    $scope.calculateModalPos($scope.top, $scope.left);
                });
            });
        });

        $rootScope.$on('hideConditionEmailEngagementtModal', function() {
            $scope.displayError = false;
            $scope.displayEmailEngagementConditionOpt = false;
        });

        $rootScope.$on('displayConditionEmailEngagementError', function(evt, emailErr, conditionErr, item) {
            $scope.emailError = emailErr;
            if (item != undefined && conditionErr) {
                $scope.conditionError[parseInt(item)] = conditionErr;
            }
        });

        var conditionCount = 2;

        $scope.getConditionList = function () {
            return {
                hasOpened: $scope.translate('canvas.condition.emailEngagement.hasOpened'),
                hasNotOpened: $scope.translate('canvas.condition.emailEngagement.hasNotOpened'),
                hasClicked: $scope.translate('canvas.condition.emailEngagement.hasClicked'),
                hasNotClicked: $scope.translate('canvas.condition.emailEngagement.hasNotClicked')
            };
        };

        $scope.isRepeated = function(condition) {
            var res = _.filter($scope.connections.data.conditions, function(item) {
                return condition === item.selectedCondition;
            }) || [];

            return res.length > 1;
        };

        //On select change we sent via paramer the selected condition and which one it is.
        //Loop in to the condition list and flag the status = true when visited and the conditionSelected fill what condition is (1,2 or 3) to know if its visited and which one did.
        $scope.selectCondition = function (condition, index) {
            if (condition != null) {
                if($scope.isRepeated(condition.selectedCondition)) {
                    $scope.connections.data.conditions[index].selectedCondition = '';
                    $rootScope.$emit('errorMsg', $scope.translate('canvas.condition.emailEngagement.repeatedOptions'));
                }
            }
        };

        //Filter the conditions to show on the selector from the condition number
        $scope.conditionFilter = function (param) {
            return function(condition) {
                return (condition.status == false || condition.conditionSelected == param);
            };
        };

        //function to add a new condition into the dom
        $scope.addNewCondition = function () {
            var index =  $scope.connections.data.conditions.length;
            $rootScope.myConnections = $scope.connections.data.conditions;

            if (!$scope.connections.data.emailNode || !$scope.connections.data.conditions[index-1].selectedCondition) {
                $rootScope.$emit('errorMsg', $scope.translate('canvas.error.condition.604'));
            } else if (index  > 3) {
                $rootScope.$emit('errorMsg', $scope.translate('canvas.error.condition.605'));
            } else {
                $scope.connections.data.conditions.push({
                    label: $scope.translate(`canvas.condition.emailEngagement.conditionLabel.${index + 1}`),
                    selectedCondition: '',
                    url: '',
                    deleteClass: 'added-condition',
                });
            }
        };

        //Function to remove conditions on the screen
        $scope.removeCondition = function (index) {
            $scope.connections.data.conditions.splice(index, 1);
            for (var i = 0; i < $scope.conditionList.length; i++) {
                if ($scope.conditionList[i].conditionSelected === 'condition' + index) {
                    $scope.conditionList[i].conditionSelected = '';
                    $scope.conditionList[i].status = false;
                }
            }
            for (var j = index; j < $scope.connections.data.conditions.length + 1; j++) {
                for (var k = 0; k < $scope.conditionList.length; k++) {
                    if ($scope.conditionList[k].conditionSelected === 'condition' + Number(j + 1)) {
                        $scope.conditionList[k].conditionSelected = 'condition' + j;
                        $scope.conditionList[k].status = true;
                        for (var h = 0; h < $scope.connections.data.conditions.length; h++) {
                            if ($scope.connections.data.conditions[h].selectedCondition === 'Has clicked URL') {
                                $scope.selectUrl[h] = true;
                            }
                        }
                    }
                }
            }
        };

        $scope.calculateModalPos = function(top, left) {
            var currentTopPercent = ((top/window.innerHeight) * 100);
            var currentLeftPercent = ((left/window.innerWidth) * 100);
            var fixedHeight = 400;
            var fixedwidth = 450;

            if((left + 160) > window.innerWidth) {
                currentLeftPercent = 20;
                left = 0;
            }

            $scope.modalTop = ( currentTopPercent + _calculateTopByPos()).toFixed(0) + '%';
            $scope.modalLeft = ( currentLeftPercent + _calculateLeftByPos()).toFixed(0) + '%';


            function _calculateTopByPos() {
                var totalTop = top + fixedHeight,
                    resTop = 0;

                if(totalTop > window.innerHeight) {
                    resTop = -38;
                }

                return resTop;
            }

            function _calculateLeftByPos() {
                var totalLeft = left + fixedwidth,
                    resLeft = 14;

                if($scope.showTip) {
                    resLeft = 22;
                }

                if(totalLeft > window.innerWidth) {
                    resLeft = -20;
                }

                return resLeft;
            }
        };

        $scope.cancel = function() {
            $scope.displayEmailEngagementConditionOpt = false;

            var node = _.find($rootScope.connections, function (conn) {
                return conn.id === $scope.connections.id;
            });

            if (!node) {
                // Execute listener when user cancel the email engagement node
                $rootScope.$broadcast('deleteEmailEngagementNode' + $scope.connections.id);
            }
        };

        $scope.save = function() {
            Intercom('trackEvent', 'AP - EmailEngagement');
            $rootScope.$emit('saveConditionEmailEngagementData' + $scope.connections.id, $scope.connections, $scope.descriptionEmpty);
        };

        //Toggle List Item to check if a checkbox is checked, If not we add it to the array of IDs, if not we delete it and just save the ones selected
        $scope.toggelListItem = function (listItem) {
            if($scope.connections.isDummy) {
                $scope.connections.data.selectedList = [];
                delete $scope.connections.isDummy;
            }

            var index = $scope.connections.data.selectedList.indexOf(listItem);
            if (index > -1) {
                $scope.connections.data.selectedList.splice(index, 1);
            } else {
                $scope.connections.data.selectedList.push(listItem);
            }

            if ($scope.connections.data.selectedList.length) {
                $scope.selectedKey = $scope.translate('commons.editSelection');
            } else {
                $scope.selectedKey = $scope.translate('commons.selectList');
            }
        };

        $scope.parseDescription = function (id) {
            var eName;
            if (!id) {
                return $scope.translate('commons.enterDetails');
            }
            for(var i = 0; i<$scope.emailList.length; i++) {
                if($scope.emailList[i].id === id) {
                    eName = $scope.emailList[i].name;
                    break;
                }
            }

            return eName;
        };
    };
})();



// WEBPACK FOOTER //
// ./app/controllers/modals/conditionEmailEngagementController.js